/**
 * Tour Spotlight Deck – Swipeable card stack for mobile
 * Activates only on viewports <= 749px via matchMedia.
 * Fallback: horizontal scroll (no-JS or desktop).
 */
(function () {
  'use strict';

  var MOBILE_MQ = '(max-width: 749px)';
  var SWIPE_THRESHOLD = 60;
  var ROTATION_FACTOR = 0.06;
  var STACK_SCALE_STEP = 0.04;
  var STACK_Y_STEP = 8;
  var MAX_VISIBLE_BEHIND = 2;

  function TourDeck(container) {
    this.container = container;
    this.cards = [];
    this.currentIndex = 0;
    this.startX = 0;
    this.startY = 0;
    this.deltaX = 0;
    this.isDragging = false;
    this.isHorizontal = null;
    this.dotsWrap = null;
    this.dots = [];
    this.srStatus = null;
    this.active = false;

    this._onPointerDown = this._onPointerDown.bind(this);
    this._onPointerMove = this._onPointerMove.bind(this);
    this._onPointerUp = this._onPointerUp.bind(this);
    this._onKeyDown = this._onKeyDown.bind(this);
  }

  TourDeck.prototype.init = function () {
    this.cards = Array.prototype.slice.call(
      this.container.querySelectorAll(':scope > li')
    );
    if (this.cards.length < 2) return;

    this.container.classList.add('tour-deck--active');
    this.active = true;
    this.currentIndex = 0;

    this._buildDots();
    this._buildSrStatus();
    this._updateStack();
    this._updateDots();
    this._announceCurrent();

    this.container.addEventListener('pointerdown', this._onPointerDown);
    this.container.addEventListener('keydown', this._onKeyDown);
    this.container.setAttribute('tabindex', '0');
  };

  TourDeck.prototype.destroy = function () {
    if (!this.active) return;
    this.container.classList.remove('tour-deck--active');
    this.active = false;

    this.container.removeEventListener('pointerdown', this._onPointerDown);
    this.container.removeEventListener('keydown', this._onKeyDown);
    this.container.removeAttribute('tabindex');

    for (var i = 0; i < this.cards.length; i++) {
      var li = this.cards[i];
      li.style.cssText = '';
      li.classList.remove('tour-deck__card--swiped', 'tour-deck__card--dragging');
    }

    if (this.dotsWrap && this.dotsWrap.parentNode) {
      this.dotsWrap.parentNode.removeChild(this.dotsWrap);
    }
    if (this.srStatus && this.srStatus.parentNode) {
      this.srStatus.parentNode.removeChild(this.srStatus);
    }
    this.dotsWrap = null;
    this.dots = [];
    this.srStatus = null;
  };

  /* ---------- Stack layout ---------- */

  TourDeck.prototype._updateStack = function () {
    var total = this.cards.length;
    for (var i = 0; i < total; i++) {
      var li = this.cards[i];
      var offset = i - this.currentIndex;

      if (offset < 0) {
        li.style.transform = 'translateX(-120%) rotate(-8deg)';
        li.style.opacity = '0';
        li.style.pointerEvents = 'none';
        li.style.zIndex = 0;
        li.classList.add('tour-deck__card--swiped');
      } else if (offset <= MAX_VISIBLE_BEHIND) {
        li.classList.remove('tour-deck__card--swiped');
        var scale = 1 - offset * STACK_SCALE_STEP;
        var ty = offset * STACK_Y_STEP;
        li.style.transform = 'translateY(' + ty + 'px) scale(' + scale + ')';
        li.style.opacity = offset === 0 ? '1' : String(1 - offset * 0.15);
        li.style.pointerEvents = offset === 0 ? 'auto' : 'none';
        li.style.zIndex = total - offset;
      } else {
        li.style.transform = 'translateY(' + (MAX_VISIBLE_BEHIND * STACK_Y_STEP) + 'px) scale(' + (1 - MAX_VISIBLE_BEHIND * STACK_SCALE_STEP) + ')';
        li.style.opacity = '0';
        li.style.pointerEvents = 'none';
        li.style.zIndex = 0;
      }
    }
  };

  /* ---------- Dots ---------- */

  TourDeck.prototype._buildDots = function () {
    this.dotsWrap = document.createElement('div');
    this.dotsWrap.className = 'tour-deck__dots';
    this.dotsWrap.setAttribute('aria-hidden', 'true');
    this.dots = [];

    for (var i = 0; i < this.cards.length; i++) {
      var dot = document.createElement('button');
      dot.className = 'tour-deck__dot';
      dot.type = 'button';
      dot.setAttribute('aria-label', 'Karte ' + (i + 1));
      dot.dataset.index = i;
      dot.addEventListener('click', this._onDotClick.bind(this, i));
      this.dotsWrap.appendChild(dot);
      this.dots.push(dot);
    }

    this.container.parentNode.insertBefore(
      this.dotsWrap,
      this.container.nextSibling
    );
  };

  TourDeck.prototype._updateDots = function () {
    for (var i = 0; i < this.dots.length; i++) {
      if (i === this.currentIndex) {
        this.dots[i].classList.add('tour-deck__dot--active');
      } else {
        this.dots[i].classList.remove('tour-deck__dot--active');
      }
    }
  };

  TourDeck.prototype._onDotClick = function (index) {
    if (index === this.currentIndex) return;
    this.currentIndex = index;
    this._updateStack();
    this._updateDots();
    this._announceCurrent();
  };

  /* ---------- Screenreader ---------- */

  TourDeck.prototype._buildSrStatus = function () {
    this.srStatus = document.createElement('div');
    this.srStatus.className = 'tour-deck__sr-status';
    this.srStatus.setAttribute('aria-live', 'polite');
    this.srStatus.setAttribute('role', 'status');
    this.container.parentNode.insertBefore(
      this.srStatus,
      this.container.nextSibling
    );
  };

  TourDeck.prototype._announceCurrent = function () {
    if (!this.srStatus) return;
    this.srStatus.textContent =
      'Karte ' + (this.currentIndex + 1) + ' von ' + this.cards.length;
  };

  /* ---------- Pointer / Touch ---------- */

  TourDeck.prototype._onPointerDown = function (e) {
    if (e.button && e.button !== 0) return;
    var li = this.cards[this.currentIndex];
    if (!li) return;

    this.isDragging = true;
    this.isHorizontal = null;
    this.startX = e.clientX;
    this.startY = e.clientY;
    this.deltaX = 0;

    li.classList.add('tour-deck__card--dragging');
    this.container.setPointerCapture(e.pointerId);

    this.container.addEventListener('pointermove', this._onPointerMove);
    this.container.addEventListener('pointerup', this._onPointerUp);
    this.container.addEventListener('pointercancel', this._onPointerUp);
  };

  TourDeck.prototype._onPointerMove = function (e) {
    if (!this.isDragging) return;

    var dx = e.clientX - this.startX;
    var dy = e.clientY - this.startY;

    if (this.isHorizontal === null) {
      if (Math.abs(dx) < 5 && Math.abs(dy) < 5) return;
      this.isHorizontal = Math.abs(dx) >= Math.abs(dy);
      if (!this.isHorizontal) {
        this._cancelDrag();
        return;
      }
    }

    e.preventDefault();
    this.deltaX = dx;

    var li = this.cards[this.currentIndex];
    if (!li) return;
    var rotation = dx * ROTATION_FACTOR;
    li.style.transform =
      'translateX(' + dx + 'px) rotate(' + rotation + 'deg)';
  };

  TourDeck.prototype._onPointerUp = function (e) {
    if (!this.isDragging) return;
    this._cleanupListeners(e);

    var li = this.cards[this.currentIndex];
    if (!li) return;
    li.classList.remove('tour-deck__card--dragging');

    if (this.deltaX < -SWIPE_THRESHOLD && this.currentIndex < this.cards.length - 1) {
      this._swipeAway(li, -1);
    } else if (this.deltaX > SWIPE_THRESHOLD && this.currentIndex > 0) {
      this._goBack();
    } else {
      this._snapBack(li);
    }
  };

  TourDeck.prototype._cancelDrag = function () {
    this.isDragging = false;
    var li = this.cards[this.currentIndex];
    if (li) li.classList.remove('tour-deck__card--dragging');
  };

  TourDeck.prototype._cleanupListeners = function (e) {
    this.isDragging = false;
    if (e && e.pointerId != null) {
      try { this.container.releasePointerCapture(e.pointerId); } catch (_) {}
    }
    this.container.removeEventListener('pointermove', this._onPointerMove);
    this.container.removeEventListener('pointerup', this._onPointerUp);
    this.container.removeEventListener('pointercancel', this._onPointerUp);
  };

  TourDeck.prototype._swipeAway = function (li) {
    li.style.transform = 'translateX(-120%) rotate(-8deg)';
    li.style.opacity = '0';
    li.classList.add('tour-deck__card--swiped');

    this.currentIndex++;
    this._updateStack();
    this._updateDots();
    this._announceCurrent();
  };

  TourDeck.prototype._goBack = function () {
    this.currentIndex--;
    this._updateStack();
    this._updateDots();
    this._announceCurrent();
  };

  TourDeck.prototype._snapBack = function (li) {
    this._updateStack();
  };

  /* ---------- Keyboard ---------- */

  TourDeck.prototype._onKeyDown = function (e) {
    if (e.key === 'ArrowLeft' && this.currentIndex < this.cards.length - 1) {
      e.preventDefault();
      this._swipeAway(this.cards[this.currentIndex]);
    } else if (e.key === 'ArrowRight' && this.currentIndex > 0) {
      e.preventDefault();
      this._goBack();
    }
  };

  /* ---------- Init per Section ---------- */

  function initAll() {
    var containers = document.querySelectorAll('[data-tour-deck]');
    var decks = [];

    var mql = window.matchMedia(MOBILE_MQ);

    function onMediaChange(mq) {
      var matches = mq.matches !== undefined ? mq.matches : mq;
      for (var i = 0; i < decks.length; i++) {
        if (matches && !decks[i].active) {
          decks[i].init();
        } else if (!matches && decks[i].active) {
          decks[i].destroy();
        }
      }
    }

    containers.forEach(function (el) {
      decks.push(new TourDeck(el));
    });

    if (mql.addEventListener) {
      mql.addEventListener('change', onMediaChange);
    } else if (mql.addListener) {
      mql.addListener(onMediaChange);
    }

    onMediaChange(mql);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
